module.exports = __webpack_public_path__ + "media/images/app_buttons/button__appStore--fr-35f2e3001877c0e363e4bccb5162a252.svg";